const style = {
  audioWrapper: {
    "& audio": {
      border: "1px solid #ccc",
      height: 36,
      borderRadius: 2,
    },
    "& audio::-webkit-media-controls-panel": {
      backgroundColor: "#fff",
    },
  },
  campaignName: {
    maxWidth: "500px",
  },
  wrapper: {
    minHeight: 324,
  },
  errorMessageWrapper: {
    backgroundColor: 'grey.50',
    borderRadius: 2,
  },
  errorAccordion: {
    '&::before': {
      height: 0,
    }
  },
  errorAccordionSummary: {
    '& .MuiAccordionSummary-content': {
      flexGrow: 0,
    }
  },
  audioExpired: {
    border: '1px solid #ccc',
    borderRadius: 2,
    color: '#ccc',
    background: '#F7F7F7'
  }
};

export default style;
